import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../../constants'

// Define a service using a base URL and expected endpoints
export const appointmentsApi = createApi({
  reducerPath: 'appointments',
  baseQuery: fetchBaseQuery({
    baseUrl: serverUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.value
      // console.log('token state', token)
      // If we have a token set in state, let's assume that we should be passing it.
      headers.set('authorization', `Bearer ${token}`)
      headers.set('Content-Type', `application/json`)
      if (token) {
        // window.localStorage.setItem('token', token)
      }
      return headers
    }
  }),
  tagTypes: ['Appointments'],
  endpoints: (builder) => ({
    fetchAppointments: builder.query({
      query: (mId) => ({
        url: `appointments?mId=${mId}`,
      }),
      providesTags: ['Appointments'],
    }),
    addAppointment: builder.mutation({
      query: ({ mId, ...rest }) => ({
        url: `appointments?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['Appointments'],
    }),
    updateAppointment: builder.mutation({
      query: ({ mId, id, ...rest }) => ({
        url: `appointments/${id}?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['Appointments'],
    }),
    deleteAppointment: builder.mutation({
      query: ({ mId, id }) => ({
        url: `appointments/${id}?mId=${mId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Appointments'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFetchAppointmentsQuery, useAddAppointmentMutation, useUpdateAppointmentMutation, useDeleteAppointmentMutation } = appointmentsApi